import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../context/logeduser'; // Your custom hook for auth context
import Login from '../components/Lodin/Login';
import EmployeeUi from '../components/Employeeui'; // Employee-specific component
import PrivateSection from './PrivateSection'; // Admin-specific component
// import SignInForm from '../components/Lodin/SignInForm'; // Your admin login component
import SignInForm from '../components/Lodin/Signin';
import EmployeeOnboardingForm from '../components/employees/EmployeeOnboardingForm';
import OnboardingSign from '../components/employees/OnboardingSign';
import OnboardingUpload from '../components/employees/OnboardingUpload';
import LandingPage from '../components/Landing/LandingPage';

const Routes = () => {
  const { authData } = useContext(AuthContext);
  const location = useLocation();
  const currentPath = location.pathname;

  // Passwordless capability links — render regardless of auth state (new hires
  // have no account; the token in the URL is the secret). The joining form must
  // also open for a logged-in HR/admin who clicks the email link.
  if (currentPath.startsWith('/onboarding/sign/')) {
    return <OnboardingSign />;
  }
  if (currentPath.startsWith('/onboarding/upload/')) {
    return <OnboardingUpload />;
  }
  if (currentPath.startsWith('/employee/form/')) {
    return <EmployeeOnboardingForm />;
  }

  // If user is not logged in
  if (!authData) {
    if (currentPath === '/admin') {
      // Show admin login only if URL is /admin
      return <SignInForm />;
    }
    // Marketing landing page is the entry point at the root. Its "Employee login"
    // button routes here to /login (which falls through to <Login/> below). Deep
    // links / 401-redirects keep landing on the login screen, unchanged.
    if (currentPath === '/' || currentPath === '/welcome') {
      return <LandingPage />;
    }
    return <Login />;
  }

  // Admin logged in successfully
  if (authData.message === 'Login successful' && authData.admin) {
    return <PrivateSection />;
  }

  // Employee logged in
  if (authData.message === 'Authentication successful.' && !authData.admin) {
    return <EmployeeUi />;
  }

  return <Login />;
};

export default Routes;
